import { API } from './API.js';
import axios from 'axios';


const url = API + '/tasting_notes/'
const debug = false;

class TastingNotes {
    // get all tastingnotes
    static get() {
        return new Promise ( async (resolve, reject) => {
            try {
                const res = await axios.get(url);
                const data = res.data;
                resolve(
                    data.map(tasting_note=> ({
                        ...tasting_note,
                        occasion: tasting_note.occasion
                    }))
                );
                if (debug) console.log("data = " + data)
            } catch(err) {
                reject(err);
            }

        })
    }

    // get one tastingnote by id
    static getone(id) {
        return axios.get(`${url}${id}`)
            .then(response => {
                if (debug) console.log('TastingNotes.getone: ',response.data)
                return response.data
            })
            .catch(error => {
                console.log('TastingNotes.getone: ',error)
            })
    }

    // get multiple tasting_notes by ids
    static getmany(ids) {
        if (!ids || ids.length === 0) return Promise.resolve([])

        return axios.post(`${url}by_ids`, { ids })
            .then(response => {
                if (debug) console.log('TastingNotes.getMany: ', response.data)
                return response.data
            })
            .catch(error => {
                console.log('TastingNotes.getMany ERROR: ', error)
                return []
            })
    }

    // create tastingnote
    static create(postdata) {
        return axios.post(url, postdata)
            .then(response => {
                if (debug) console.log('TastingNotes.create OK : ',response)
                return response.data._id
            })
            .catch(error => {
                console.log('TastingNotes.create NOK: ',error)
            })
    }

    static update(id,postdata) {
        if (debug) console.log('TastingNotes.update: id=',id)
        if (debug) console.log('TastingNotes.update: postdata=',postdata)
        return axios.put(`${url}${id}`, postdata)
            .then(response => {
                if (debug) console.log('TastingNotes.update: ',response)
                return id
            })
            .catch(error => {
                console.log('TastingNotes.update: ',error)
            })
    }

    // delete tastingnote
    static delete(id) {
        return axios.delete(`${url}${id}`)
    } 
}

export default TastingNotes